import axios from 'axios'
import router from '@/router'
// import { Message } from 'element-ui'
import store from '../store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import { getToken } from '@/utils/auth'
import { Toast } from 'vant'

NProgress.configure({ showSpinner: false })
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL // api 的 base_url
  // timeout: 5000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers.Authorization = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
      // config.headers.Authorization = 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxNDY0MTI0ODkyNjI1NTIyNjkwIiwiYXV0aCI6IjE0NjA0NTE0MzIwNzEzNjQ2MTAiLCJleHAiOjE2MzgzNjM0MzN9.36SapxDDIjblgwOKBaRqP3jZsKxSbAa_t1yoQtvAgHS6D2OquKG7jfhdGwCoJ491m5B_yNSVbCE3-F_lCyCKsg'
      // config.headers.Authorization = 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxNDYzNzY1MDExNDAxODM4NTkzIiwiYXV0aCI6IjE0NDg1Mzc3OTQ2MzM0NDk0NzMiLCJleHAiOjE2NTUyOTg3NzN9.eRruAfhD0YB2kC0m0qsgSGn5Ogky5bjl16a6KvK43Ftgbd9wlspO-ZKO4cCxjy_5719-vYNUDo1tW1HLhPP8Aw'
      NProgress.start()
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    NProgress.done()
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    if (response.data.code === 400) {
      Toast.fail(response.data.message)
      NProgress.done()
      return response.data
    } else if (response.data.code === 401) {
      Toast.fail(response.data.message)
      NProgress.done()
      return response.data
    } else {
      NProgress.done()
      return response.data.data || response.data || response
    }
  },
  error => {
    const res = error.response.data
    if (res.code === 440) {
      Toast.fail('登录超时,请重新登陆')
      store.dispatch('FedLogOut').then(() => {
      })
      NProgress.done()
    } else if (res.code === 403) {
      router.push('/403')
      Toast.fail('没有该权限,请联系管理员')
      NProgress.done()
    } else if (res.code === 404) {
      router.push('/404')
      Toast.fail('页面丢失了')
      NProgress.done()
    } else if (res.code === 500) {
      Toast.fail(res.message)
      NProgress.done()
    } else {
      NProgress.done()
      Toast.fail('请稍后再试')
    }
    return Promise.reject(error)
  }
)

export default service
